webpackJsonp([125579235050013],{

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BannerLanding = __webpack_require__(5);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	var _BannerSection = __webpack_require__(6);
	
	var _BannerSection2 = _interopRequireDefault(_BannerSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PastoralCouncil = function PastoralCouncil(props) {
	  var _props$data$contentfu = props.data.contentfulPastoralCouncil,
	      title = _props$data$contentfu.title,
	      metaDescription = _props$data$contentfu.metaDescription,
	      headerBackgroundImage = _props$data$contentfu.headerBackgroundImage,
	      sectionFourHeading = _props$data$contentfu.sectionFourHeading,
	      sectionFourContent = _props$data$contentfu.sectionFourContent;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'main', className: 'alt-colors' },
	    _react2.default.createElement(_BannerLanding2.default, {
	      title: title,
	      desc: metaDescription,
	      bg: headerBackgroundImage !== null ? headerBackgroundImage.file.url : undefined
	    }),
	    _react2.default.createElement(
	      'section',
	      { id: 'section-four' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_BannerSection2.default, { sectionContent: sectionFourHeading })
	        ),
	        sectionFourContent !== null ? _react2.default.createElement('div', {
	          dangerouslySetInnerHTML: {
	            __html: sectionFourContent.childMarkdownRemark.html
	          }
	        }) : undefined
	      )
	    ),
	    _react2.default.createElement('hr', null)
	  );
	}; // eslint-disable-line import/no-extraneous-dependencies
	// import YouTube from 'react-youtube'
	
	
	PastoralCouncil.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = PastoralCouncil;
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pastoralCouncil = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PastoralCouncil = __webpack_require__(168);
	
	var _PastoralCouncil2 = _interopRequireDefault(_PastoralCouncil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PastoralCouncilPage = function PastoralCouncilPage(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'PastoralCouncil | ' + props.data.site.siteMetadata.title
	      )
	    ),
	    _react2.default.createElement(_PastoralCouncil2.default, { data: props.data })
	  );
	};
	
	// components
	// eslint-disable-line import/no-extraneous-dependencies
	
	
	PastoralCouncilPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = PastoralCouncilPage;
	var pastoralCouncil = exports.pastoralCouncil = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pastoral-council-js-3de4d71ddcdebb1b95a6.js